<template>
  <div v-loading="moduleLoadingOne" class="sectionContainer">
    <div v-if="!moduleLoadingOne">
      <Title title="Seguimiento"
             subtitle="Sigue el progreso de las rutas activas"/>
      <div class="content">
        <div class="top">
          <div class="search-box greenAppend">
            <TracingSearch
              :valueInput="variable"
              :toSearch="clickOnClientValue"
              @data="infoData"
              @loaderSearch="updateLoader"
              @notFound="setNotFound"
              @type="infoType"
              @active="showHide"
              @restart="homeView" />
          </div>
          <div class="enterpriseFilter">
            <el-select
              v-model="selectedId"
              placeholder="Ej: Transportes Atenas"
              filterable
              clearable>
              <el-option
                v-for="enterprise in data.enterprises"
                :key="enterprise.id"
                :label="enterprise.name"
                :value="enterprise.id"/>
            </el-select>
          </div>
          <div class="ns">
            <div class="ns-diario">
              <TracingDataDesk
                deskTitle="NS"
                deskSubtitle="Diario"
                :deskNumber="`${nsDiario}`"/>
            </div>
            <div class ="ns-mensual">
              <TracingDataDesk
                deskTitle="NS"
                deskSubtitle="Mensual"
                :deskNumber="`${nsMensual}`"/>
            </div>
          </div>
        </div>
        <!--Visualizacion de vista home-->
        <div v-if="searchActive === 0">
          <div v-if="!loadEmpty">
            <el-row class="paddingTop paddingContainer" v-loading="loading">
              <el-col :xs="24" :sm="24" :md="24">
                <el-row>
                  <el-col :span='24'>
                    <TracingProgressBar
                      v-loading="loadComponents"
                      :sectionName="selectedEnterprise"
                      :progressData="selectedResult" />
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="24" :sm="24" :md="{span: 12, push: 12}" class="paddingTop gutterStart" >
                <el-row>
                  <el-col :span='24'>
                    <TracingDelayedTrucks
                      v-loading="loadComponents"
                      :sectionName="selectedEnterprise"
                      :delayedTrucksTotalData="selectedResult"/>
                  </el-col>
                </el-row>
              </el-col>
              <el-col
                class="paddingTopSm gutterStart"
                :xs="24" :sm="24" :md="{span: 12, pull: 12}">
                <TracingActualProgress
                  v-loading="loadComponents"
                  setPadding="160"
                  :sectionName="selectedEnterprise"
                  :chartData="selectedResult"
                  :elementId="'progressChart'" />
              </el-col>
            </el-row>
            <el-row
              class="paddingTop paddingContainer"
              :class="windowWidth > 768 ? 'paddingContainer' : ''"
              v-loading="loading">
              <el-col :span="24">
                <TracingInternalGraph
                  :elementId="'tracingChart'"
                  :chartType="chartDisplayType"
                  :chartData="chartDataInfo"
                  v-on:sendDataToParent="takenInfo($event)"/>
              </el-col>
            </el-row>
          </div>
          <div v-else class="emptyStyle">
            <NotFound
              imgName="fb-map.svg"
              textGreen="No se encontraron"
              textGrey="rutas para hoy" />
          </div>
        </div>
        <!-- Visualizacion de resultados del buscador -->
        <div v-else>
          <TracingClient
            class="paddingContainer paddingTop"
            v-loading="loadingState"
            v-if="typeSearch === 2"
            @restart="homeView"
            @clickOnClient="sendClientData"
            :dataClient="dataSearchClient"
            :routes="routes"
            :notFound="displayNotFound"
          />
          <TracingDriver
            class="paddingContainer paddingTop"
            v-loading="loadingState"
            v-if="typeSearch === 1"
            @restart="homeView"
            @clickOnClient="sendClientData"
            :dataDriver="dataSearchDriver"
            :notFound="displayNotFound"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';
import TracingSearch from '../components/TracingSearch.vue';
import TracingDataDesk from '../components/TracingDataDesk.vue';
import TracingProgressBar from '../components/TracingProgressBar.vue';
import TracingActualProgress from '../components/TracingActualProgress.vue';
import TracingDelayedTrucks from '../components/TracingDelayedTrucks.vue';
import NotFound from '../components/Base404.vue';
import TracingClient from '../components/TracingClient.vue';
import TracingDriver from '../components/TracingDriver.vue';
import TracingInternalGraph from '../components/TracingInternalGraph.vue';


export default {
  props: {
    windowWidth: {
      type: Number,
    },
  },
  name: 'Tracing',
  components: {
    Title,
    TracingInternalGraph,
    TracingDriver,
    TracingClient,
    TracingDelayedTrucks,
    TracingSearch,
    TracingDataDesk,
    TracingProgressBar,
    TracingActualProgress,
    NotFound,
  },
  data() {
    return {
      loading: false,
      loadComponents: false,
      moduleLoadingOne: true,
      loadEmpty: false,
      chartDisplayType: '',
      displayNotFound: false,
      searchActive: 0,
      variable: 0,
      typeSearch: 0,
      dataSearchDriver: {},
      dataSearchClient: {},
      dataDriverforClient: {},
      input: {},
      routes: [],
      typeResult: 0,
      nsDiario: 100,
      nsMensual: 100,
      chartDataInfo: [],
      toDelete: [{
        progress: {
          delayed: 5,
          delivered: 10,
          in_route: 20,
          rejected: 5,
          total: 40,
        },
      }],
      timeInit: '2014-01-01',
      timeEnd: '2018-08-08',
      loadingState: true,
      searchedInfo: {},
      clickOnClientValue: '',
      selectedId: '',
      selectedEnterprise: 'General',
      selectedResult: [],
      data: {
        enterprises: [],
      },
    };
  },
  methods: {
    setNotFound(data) {
      this.displayNotFound = data;
    },
    showHide(active) {
      this.searchActive = active;
    },
    getEnterprisesList() {
      apiRequest({
        module: 'planning',
        service: 'enterprises',
        params: {
          limit: 6000,
        },
      }).then((data) => {
        this.data.enterprises = data.data;
      }).catch(() => {
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        }); */
      });
    },
    sendClientData(data) {
      // this.$router.push({ name: 'Tracing', query: { v: data.vehicle.patent } });
      this.clickOnClientValue = data.toString();
    },
    /* getNS() {
      apiRequest({
        module: 'tracing',
        service: 'ns',
      }).then((result) => {
        if (result.data.daily_ls === -1) {
          this.nsDiario = ' - ';
        } else {
          const daily = Math.round(result.data.daily_ls * 1000) / 10;
          this.nsDiario = `${daily}%`;
        }
        if (result.data.monthly_ls === -1) {
          this.nsMensual = '-';
        } else {
          const montly = Math.round(result.data.monthly_ls * 1000) / 10;
          this.nsMensual = `${montly}%`;
        }
      }).catch(() => {
      });
    }, */
    getEnterprises() {
      const init = new Date();
      const initTime = moment(init).format('YYYY-MM-DD');
      const finish = init.setDate(init.getDate() + 1);
      const finishTime = moment(finish).format('YYYY-MM-DD');
      apiRequest({
        module: 'tracing',
        service: 'enterprises',
        params: {
          time_init: initTime,
          time_end: finishTime,
        },
      }).then((result) => {
        this.chartDataInfo.length = 0;
        this.chartDataInfo.push(result.data);
      }).catch(() => {
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        }); */
      });
    },
    getRouteClientView(vehicle) {
      apiRequest(vehicle).then((res) => {
        this.dataDriverforClient = res.data;
        this.routes = [this.dataDriverforClient];
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar información',
        });
      });
    },
    infoData(data) {
      this.searchedInfo = data;
      // driver
      if (this.typeSearch === 1) {
        // this.dataSearchDriver = [];
        this.dataSearchDriver = this.searchedInfo;
        this.$router.push({ name: 'Tracing', query: { v: this.dataSearchDriver[0].vehicle.patent } });
      }
      // client
      if (this.typeSearch === 2) {
        this.dataSearchClient = this.searchedInfo;
        this.$router.push({ name: 'Tracing', query: { v: data.suborder.code } });
        /* const { patent } = this.dataSearchClient.vehicle;
        const vehicle = {
          module: 'tracing',
          service: 'vehicle',
          params: {
            patent,
          },
        };
        this.getRouteClientView(vehicle); */
      }
      this.loadingState = false;
    },
    updateLoader(data) {
      this.loadingState = data;
    },
    infoType(type) {
      // primera funcion cuando se presiona "buscar"
      this.typeSearch = type;
    },
    homeView(restart) {
      this.searchActive = restart;
      this.variable = this.variable + 1;
    },
    takenInfo(element) {
      if (element.name) {
        this.selectedId = element.id;
        this.selectedEnterprise = element.name;
      } else {
        this.selectedId = element;
        this.selectedEnterprise = 'General';
      }
    },
    takenInfoEnterprise(id) {
      const enterprise = this.data.enterprises.find(e => e.id === id);
      return enterprise;
    },
    getMainData() {
      const init = new Date();
      init.setHours(0, 0, 0, 0);
      const initTime = moment.utc(init).toISOString();
      const finish = init.setDate(init.getDate() + 1);
      const finishTime = moment.utc(finish).toISOString();
      let sId = '';
      if (this.selectedId !== '' && this.selectedId !== null) {
        sId = `/${this.selectedId}`;
        this.selectedEnterprise = this.takenInfoEnterprise(this.selectedId).name;
      } else {
        this.selectedEnterprise = 'General';
      }
      this.loadComponents = true;
      apiRequest({
        module: 'tracing',
        service: 'get_tracing_data',
        pathparam: { id: sId },
        params: {
          time_init: initTime,
          time_end: finishTime,
        },
      }).then((result) => {
        this.loadEmpty = false;
        this.selectedResult.pop();
        this.selectedResult.push(result.data);
        this.moduleLoadingOne = false;
        this.loadComponents = false;
      }).catch(() => {
        this.loadEmpty = true;
        this.moduleLoadingOne = false;
        this.loadComponents = false;
        /* this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        }); */
      });
    },
    takeDate() {
      const today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      this.timeInit = `${yyyy}-${mm}-${dd}`;
      const date = new Date();
      const dateHour = date.toISOString();
      this.timeEnd = dateHour;
    },
  },
  beforeMount() {
    this.getEnterprisesList();
    if (this.windowWidth < 1024) {
      this.chartDisplayType = 'horizontalBar';
    } else {
      this.chartDisplayType = 'bar';
    }
  },
  created() {
    this.$options.interval = setInterval(() => {
      this.getMainData();
      this.getEnterprises();
      // this.getNS();
      this.infoData(this.searchedInfo);
    }, 200000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  mounted() {
    this.getEnterprises();
    this.getMainData();
    // this.getNS();
  },
  watch: {
    selectedResult(newEl) {
      if (newEl[0].progress.total > 0) {
        this.loadEmpty = false;
      } else {
        this.loadEmpty = true;
      }
    },
    windowWidth(el) {
      if (el < 1024) {
        this.chartDisplayType = 'horizontalBar';
      } else {
        this.chartDisplayType = 'bar';
      }
    },
    selectedId() {
      this.getMainData();
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
    },
  },
};
</script>

<style lang="scss" scoped>
  .enterpriseFilter {
    min-width: 200px;
    margin-left: 20px;
  }
  .home-view {
    width: 100%;
    height: 100%;
  }
  .content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 2em;
  }
  .top {
    display: flex;
    justify-content: space-evenly;
    padding: 0 2em;
  }
  .ns {
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    min-width: 38%;
    margin-top: -0.6em;
  }
  .ns-diario {
    margin-right: 2em;
  }
  .search-box {
    width: 100%;
  }
  .paddingContainer {
    padding: 0 2em;
    margin: 0 !important;
  }
  .paddingTop {
    padding-top: 1.5em;
  }
  .gutterStart {
    padding-right: 10px;
  }
  .gutterEnd {
    padding-left: 10px;
  }
  .fb-map {
    width: 320px;
  }

  .sectionContainer.wrap {
    overflow: scroll !important;
  }

  .titleStyle {
    font-size: 2em;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
  }
  .green {
    color: $fb-green;
  }
  .grey {
    color: $fb-grey-light-50;
  }
  .emptyStyle {
    margin-top: 2em;
  }
  .tracingChart {
    z-index: 90;
  }
  @media only screen and (max-width: 1010px) and (min-width: 768px) {
    .ns {
      min-width: 55%;
    }
  }
  @media only screen and (max-width: 768px) {
    .sectionContainer {
      width: 100vw;
      position: relative;
    }
    .paddingTopSm {
      padding-top: 1em;
    }
    .paddingTop {
      padding-top: 1em;
    }
    .gutterStart {
      padding-right: 0;
    }
    .gutterEnd {
      padding-left: 0;
    }
    .titleStyle {
      font-size: 1.5em;
    }
  }
  @media only screen and (max-width: 767px) {
    .top {
      flex-direction: column;
    }
    .enterpriseFilter{
      margin-left: 0;
      margin-top: 0.5em;
    }
    .ns {
      justify-content: center;
      margin-top: 0.5em;
      background: $fb-grey-light-94;
      padding: 1em;
    }
  }
</style>
